import { useFormContext } from 'react-hook-form';
import useTranslation from 'next-translate/useTranslation';

import type { FunctionComponent } from 'react';
import type { TypeSelectProps } from './types';

/**
 * Select
 */
export const Select: FunctionComponent<TypeSelectProps> = ({
  className = '',
  elements = [],
  name,
  defaultValue,
  label,
  requiredMessage,
  commonOptions,
}: TypeSelectProps) => {
  const {
    register,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();
  const { t } = useTranslation('common');

  const commonElements = [
    {
      label: t('components.organisms.contactForm.selectOptions.option1'),
      value: t('components.organisms.contactForm.selectOptions.value1'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option2'),
      value: t('components.organisms.contactForm.selectOptions.value2'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option3'),
      value: t('components.organisms.contactForm.selectOptions.value3'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option4'),
      value: t('components.organisms.contactForm.selectOptions.value4'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option5'),
      value: t('components.organisms.contactForm.selectOptions.value5'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option6'),
      value: t('components.organisms.contactForm.selectOptions.value6'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option7'),
      value: t('components.organisms.contactForm.selectOptions.value7'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option8'),
      value: t('components.organisms.contactForm.selectOptions.value8'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option9'),
      value: t('components.organisms.contactForm.selectOptions.value9'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option10'),
      value: t('components.organisms.contactForm.selectOptions.value10'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option11'),
      value: t('components.organisms.contactForm.selectOptions.value11'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option12'),
      value: t('components.organisms.contactForm.selectOptions.value12'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option13'),
      value: t('components.organisms.contactForm.selectOptions.value13'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option14'),
      value: t('components.organisms.contactForm.selectOptions.value14'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option15'),
      value: t('components.organisms.contactForm.selectOptions.value15'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option16'),
      value: t('components.organisms.contactForm.selectOptions.value16'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option17'),
      value: t('components.organisms.contactForm.selectOptions.value17'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option18'),
      value: t('components.organisms.contactForm.selectOptions.value18'),
    },
    {
      label: t('components.organisms.contactForm.selectOptions.option19'),
      value: t('components.organisms.contactForm.selectOptions.value19'),
    },
  ];

  if (commonOptions || !elements?.length) {
    elements = commonElements;
  }

  const elemntIndex = elements.findIndex(
    (elemt) => defaultValue?.value === elemt.value.toString()
  );

  const selectValidation = (value: any) =>
    value !== '-1' || t('components.organisms.contactForm.invalidOption');

  return (
    <div>
      <label
        htmlFor={name}
        className={`text-other--label-form uppercase ${
          errors[name] && 'text-[#ff0000]'
        }`}
      >
        {label}
        {requiredMessage && ' *'}
      </label>
      <select
        id={name}
        {...register(name, {
          ...(requiredMessage !== undefined
            ? {
                required: requiredMessage,
                validate: selectValidation,
              }
            : {
                required: requiredMessage,
              }),
        })}
        name={name}
        defaultValue={
          elemntIndex !== -1
            ? defaultValue
              ? defaultValue.value
              : 0
            : elemntIndex
        }
        className={`text-body ${
          errors[name]
            ? 'border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]'
            : 'text-body--primary border-primary-400 text-primary-400 placeholder-primary-400'
        }   w-full cursor-pointer border-b  bg-transparent pb-2  outline-none ${className}`}
        onChange={async (e) => {
          setValue(name, e.target.value);
          await trigger(name);
        }}
      >
        {defaultValue && elemntIndex === -1 ? (
          <option value={defaultValue.value}>{defaultValue.label}</option>
        ) : null}
        {elements?.map((child, index) => (
          <option
            {...(child.disabled && { disabled: true })}
            className="w-full"
            key={index}
            value={child.value}
          >
            {child.label}
            {child.disabled ? t('components.atoms.select.soon') : ''}
          </option>
        ))}
      </select>
      {errors[name] && (
        <span className="text-other--detail text-[#ff0000]">
          {errors[name].message}
        </span>
      )}
    </div>
  );
};

Select.displayName = 'Select';
